import { Wallet } from "../../../types/wallet";

export const sortDisabledWallets = (a: Wallet, b: Wallet) => {
    return (a.provider.enabled === b.provider.enabled) ? 0 : a.provider.enabled ? -1 : 1;
}